export enum ReleaseStatusEnum {
  READY = 'READY',
  IN_INSPECTION = 'IN_INSPECTION',
  REJECTED_INSPECTION = 'REJECTED_INSPECTION',
  DISTRIBUTED = 'DISTRIBUTED',
  TAKEN_DOWN = 'TAKEN_DOWN',
}
